// extracted by mini-css-extract-plugin
export default {"end":"end_end__OctDD","bottom":"end_bottom__szoBg"};